export default __webpack_public_path__ + "static/media/190629_190332_Joe and Stuart 2.a64f3f78.jpg";